import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { useAuth } from '~modules/auth/model';
import { Loading } from '~modules/auth/ui';
import { Header } from '~shared/ui/header/header';
import { Sidebar } from '~shared/ui/sidebar/sidebar';

export function PrivateWrapper() {
	const { user, logout, isPending, error } = useAuth();

	const [isSidebarOpen, setIsSidebarOpen] = useState(false);

	const toggleSidebar = () => {
		setIsSidebarOpen(!isSidebarOpen);
	};

	useEffect(() => {
		if (error) {
			logout();
		}
	}, [error, logout]);

	if (isPending) return <Loading />;

	if (!user) {
		return null;
	}

	return (
		<>
			<Header onToggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
			<div className="flex h-full">
				<Sidebar isOpen={isSidebarOpen} />
				<main
					className={`w-full h-full transition-all duration-300 overflow-y-auto ${
						isSidebarOpen ? 'lg:ml-72' : ''
					}`}
				>
					<Outlet />
				</main>
			</div>
		</>
	);
}
